<template>
  <div
    class="container-fluid main-wrapper !px-0"
    style="background: #12102e; height: 140vh"
  >
    <div
      class="pt-[20px] pb-[100px] flex flex-col items-center w-full"
      style="
        background-image: url('https://www.burma368.net/static/image/account/wallet-background.png');
      "
    >
      <h2
        class="text-[18px]"
        style="color: hsla(0, 0%, 100%, 0.5)"
      >
        ဂိမ်းအကောင့်တွင်းရှိငွေ
      </h2>
      <h1 class="!text-[28px] font-meidum text-white">
        {{ Number($store.state.amount).toLocaleString() }} ฿
      </h1>
      <div class="flex items-center mt-[20px] gap-4">
        <button
          @click="$router.push('/deposit')"
          class="!text-[#390e92] py-0 px-[40px] cursor-pointer !font-medium !text-[20px] !rounded-full h-[53px] bg-white"
        >
          {{ $t("setting.deposit") }}
        </button>
        <button
          @click="$router.push('/withdraw')"
          class="!text-white py-0 px-[40px] cursor-pointer border-[1px] border-white !font-medium !text-[20px] !rounded-full h-[53px] bg-transparent"
        >
          {{ $t("setting.withdraw") }}
        </button>
      </div>
    </div>
    <div
      class="col-12 p-0 rounded-[20px] translate-y-[-60px] !pt-5 !pb-20"
      style="background-color: #2b185d; height: 500px; overflow: auto"
    >
      <div class="border-0 d-flex flex-column text-white px-3">
        <div class="d-flex justify-content-between items-center">
          <h3 class="mb-0 text-white pl-2 pt-2">
            {{ $t("transaction.transactions") }}
          </h3>
          <div class="tabs gap-2 d-flex">
            <button
              type="button"
              class="px-3 py-1 !rounded-full border-[1px] border-white"
              v-for="tab in tabs"
              :key="tab.name"
              @click="selectedTab = tab.name"
              :class="{ 'bg-white !text-[#390e92]': selectedTab === tab.name }"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </div>

      <div class="table betslip-table pb-3 bg-transparent pt-3">
        <div class="tab-content pb-8 w-max">
          <component :is="currentTabComponent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserDepositTable from "@/components/history/UserDepositTable.vue";
import UserTransactions from "@/components/history/UserTransactions.vue";
import UserWithdrawTable from "@/components/history/UserWithdrawTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    UserTransactions,
    UserDepositTable,
    UserWithdrawTable,
  },
  data() {
    return {
      selectedTab: "transactions",
      tabs: [
        {
          name: "transactions",
          label: "ကစားမှတ်တမ်း",
          component: "UserTransactions",
        },
        {
          name: "deposits",
          label: this.$t("transaction.deposit"),
          component: "UserDepositTable",
        },
        {
          name: "withdraws",
          label: this.$t("transaction.withdraw"),
          component: "UserWithdrawTable",
        },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find((t) => t.name === this.selectedTab);
      return tab ? tab.component : null;
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>

<style scoped>
.betslip-table {
  background: white;
}

.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}

.main-wrapper {
  padding: 7px !important;
}

.btn {
  height: 30px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-right: 1rem !important;
  padding-left: 1rem !important;
  margin-top: 3px !important;
  margin-bottom: 3px !important;
  box-shadow: none !important;
  background: #282a31 !important;
  white-space: nowrap;
}

.btn-primary.active {
  /* background: linear-gradient(
    to bottom,
    #ffc500 0%,
    #ff4500 50%,
    #c71600 100%
  ) !important;
  color: white !important; */
  background: #c7a241 !important;
  font-weight: 600;
  font-size: 1rem;
  color: black !important;
}
</style>
